import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IApiSecertCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class ApiSecretCredentialsStore implements ICredentialsStore {
    private _changes: IApiSecertCredentialsModel = {} as IApiSecertCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get apiSecret() { return this._changes.api_secret; };
    public get internalName() { return this._changes.internal_name; };
    public get apiKey() { return this._changes.api_key; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };
    
    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setApiSecret(value: string) {
        this._changes.api_secret = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default ApiSecretCredentialsStore;
